import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import CSSModules from 'helpers/CSSModulesUtil'
import { List, ListDivider } from 'react-toolbox/lib/list'
import T from 'i18n-react'

import Body from 'components/typography/body1/index'
import ListItem from './ListItem'
import { compose, branch, renderComponent } from 'recompose'

import styles from './styles.scss'

const withStyle = CSSModules(styles)

const FileList = ({ onInternal, files, onRemove, onRename, onRenameDescription, onPreview, onDownload }) => {
  return (
    <List theme={styles}>
      {
        files.map((file, index) => (
          <ListItem
            {...file}
            onPreview={() => onPreview(file.fileId, file.name, index)}
            onDownload={() => onDownload(file.fileId, file.name)}
            onInternal={() => onInternal(file.id, file.internal)}
            onRemove={() => onRemove(file.id)}
            onRename={() => onRename(file.id)}
            onRenameDescription={() => onRenameDescription(file.id)}
            key={file.fileId}
          />
        )).reduce((final, item, index) => {
          final.push(<ListDivider theme={styles} key={`divider_${item.props.id}`}/>)
          final.push(item)
          return final
        }, [])
      }
    </List>
  )
}
const EmptyFileList = () => {
  return (
    <div styleName='emptyList'>
      <Body>{T.translate('containers.project.fileSection.list.empty')}</Body>
    </div>
  )
}

export default compose(
  branch(
    R.pathEq(['files', 'length'], 0),
    renderComponent(withStyle(EmptyFileList))
  ),
  withStyle
)(FileList)
